import { render, staticRenderFns } from "./HousingHelpModal.vue?vue&type=template&id=20f82aca&"
import script from "./HousingHelpModal.vue?vue&type=script&lang=js&"
export * from "./HousingHelpModal.vue?vue&type=script&lang=js&"
import style0 from "./HousingHelpModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports